import { addDamagedVehicleAdjusterFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedVehicleAdjuster/addDamagedVehicleAdjusterQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useAddDamagedVehicleAdjusterQueryOptions = () => {
  return useMutation({
    mutationKey: ['addDamagedVehicleAdjuster'],
    mutationFn: addDamagedVehicleAdjusterFunction,
  });
};
